/** @license ISC License (c) copyright 2019 original and current authors */
/** @author Benny Powers (bennypowers) */

module.exports =
  require('../core/isMap')
